export const fromEntries = <K extends string, V extends unknown>(
  arr: Array<[K, V]>,
): Record<K, V> => {
  const obj = {} as Record<K, V>;
  arr.forEach(([k, v]) => {
    obj[k] = v;
  });
  return obj;
};
